import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"ma-0 pa-0 d-flex justify-center",attrs:{"fluid":""}},[_c(VContainer,{staticClass:"ma-0 pa-2 pt-6"},[_c(VRow,{attrs:{"no-gutters":""}},_vm._l((_vm.prop_settings.useWidgets.filter((o) => {
          if (_vm.prop_widgets[o].nutzer_sehen) {
            return o;
          }
        })),function(idWidget,idx){return _c(VCol,{key:idx,attrs:{"cols":"12","lg":_vm.colsLG}},[(idWidget === 1)?_c('Widget1Newsfeed',{attrs:{"prop_widget":_vm.prop_widgets['1'],"prop_settings":_vm.prop_settings}}):_vm._e(),(idWidget === 2)?_c('Widget2KinderAusnahmen'):_vm._e()],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }